import { border, borderBottom, display, fontSize } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { UserAuth } from "../../utils/AuthContext";
import { toArabicWord } from "number-to-arabic-words/dist/index-node.js";
import Image from "../../components/Image";
import axios from "axios";

const CashierReceipt = React.forwardRef((props, ref) => {
  const { invoiceNumber, invoiceDate, cart, netPrice, originalPrice } = props;
  const now = new Date();

  const [loadingInput, setLoadingInput] = useState(false);
  const [invoice, setInvoice] = useState(false);

  useEffect(() => {
    getNewInvoiceNumber();
  }, []);

  const { userData } = useContext(UserAuth);

  const styles = {
    container: {
      width: "80mm",
      padding: "5px",
      fontFamily: "Tajawal",
      direction: "rtl",
      textAlign: "right",
      display: "flex",
      flexDirection: "column",
      minHeight: "100%", // Ensure container takes full height
      justifyContent: "space-between", // This will push footer to bottom
    },
    header: {
      textAlign: "center",
      marginBottom: "10px",
    },
    title: {
      fontSize: "18px",
      fontWeight: "bold",
      marginBottom: "5px",
    },
    invoiceInfo: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "12px",
      marginBottom: "10px",
      borderBottom: "1px dashed #000",
      paddingBottom: "5px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginBottom: "10px",
    },
    th: {
      borderBottom: "1px solid #000",
      padding: "3px",
      fontSize: "12px",
    },
    td: {
      padding: "3px",
      fontSize: "12px",
      borderBottom: "1px solid #ddd",
    },
    totalRow: {
      fontWeight: "bold",
      borderTop: "1px dashed #000",
      borderBottom: "1px dashed #000",
    },
    footer: {
      fontSize: "12px",
      textAlign: "center",
      // marginTop: "auto", // This will push the footer to the bottom
      top: "0px",
      borderTop: "1px solid #aaa",
      width: "fit-content",
      margin: "0 auto",
      paddingTop: "10px",
    },
    centerText: {
      textAlign: "center",
      marginBottom: "15px",
      fontSize: "12px",
      display: "flex",
      flexDirection: "column",
      gap: "15px",
    },
    contentWrapper: {
      flex: 1, // This will make the content take available space
    },
  };

  const getNewInvoiceNumber = async () => {
    try {
      const newInvoiceNumber = await axios.get(
        `${process.env.REACT_APP_URL}/sellInvoice`,
        {
          params: {
            organizationId: userData?.organizationId,
          },
        }
      );
      setInvoice((prev) => ({
        ...prev,
        id: newInvoiceNumber?.data?.invoiceNumber,
        documentPath: newInvoiceNumber?.data?.document?.[0]?.path,
      }));
    } catch (error) {
      console.error("Failed to get a new invoice number");
    } finally {
      setLoadingInput(false);
    }
  };

  return (
    <div style={{ display: "none" }}>
      <div ref={ref} style={styles.container}>
        <div style={styles.contentWrapper}>
          <div style={styles.header}>
            {/* <div style={styles.title}>فاتورة</div>
            <div>{userData?.organizationName}</div> */}
            {invoice?.documentPath && (
              <Image
                className="u-width_full-width"
                imagePath={invoice?.documentPath}
                mode="show"
                imgClasses="u-width_full-width"
              />
            )}
          </div>

          <div style={styles.invoiceInfo}>
            <div>
              <div>رقم الفاتورة: {invoiceNumber}</div>
              <div>البائع: {userData?.username}</div>
            </div>
            <div>
              <div>التاريخ: {invoiceDate}</div>
              <div>
                الوقت:{" "}
                {now.getHours() +
                  ":" +
                  now.getMinutes().toString().padStart(2, "0")}
              </div>
            </div>
          </div>

          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>التفاصيل</th>
                <th style={styles.th}>الكمية</th>
                <th style={styles.th}>السعر</th>
                <th style={styles.th}>القيمة</th>
              </tr>
            </thead>
            <tbody>
              {cart.map((item, index) => (
                <tr key={index}>
                  <td style={styles.td}>{item.name}</td>
                  <td style={styles.td}>{item.quantity}</td>
                  <td style={styles.td}>{item.price.toLocaleString()}</td>
                  <td style={styles.td}>
                    {(item.quantity * item.price).toLocaleString()}
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan="3" style={{ ...styles.td, ...styles.totalRow }}>
                  المجموع
                </td>
                <td style={{ ...styles.td, ...styles.totalRow }}>
                  {originalPrice.toLocaleString()}
                </td>
              </tr>
              <tr>
                <td colSpan="3" style={styles.td}>
                  الخصم
                </td>
                <td style={styles.td}>
                  {(originalPrice - netPrice).toLocaleString()}
                </td>
              </tr>
              <tr>
                <td colSpan="3" style={{ ...styles.td, ...styles.totalRow }}>
                  الصافي
                </td>
                <td style={{ ...styles.td, ...styles.totalRow }}>
                  {netPrice.toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>

          <div style={styles.centerText}>
            <div>فقط {toArabicWord(netPrice)} دينار عراقي لا غير</div>
            <div>شكراً لزيارتكم</div>
          </div>
        </div>

        <div style={styles.footer}>
          <div>برنامج إحسبلي للإدارة والمحاسبة</div>
          <div>www.alhabbar.com</div>
        </div>
      </div>
    </div>
  );
});

export default CashierReceipt;
